/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./remove-json-category-config.vue?vue&type=template&id=2f207eac&scoped=true&"
import script from "./remove-json-category-config.vue?vue&type=script&lang=js&"
export * from "./remove-json-category-config.vue?vue&type=script&lang=js&"
import style0 from "./remove-json-category-config.vue?vue&type=style&index=0&id=2f207eac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f207eac",
  null
  
)

export default component.exports